import { useCallback } from 'react';
import { fetchLogin } from '@/store/auth/actions';

export const ConnectWithCalForm = ({
  variant,
  user,
  children,
  dispatch,
  oauthFor = 'calendar',
}) => {
  const onSubmit = useCallback(
    async (event) => {
      const form = event.target;

      // proceed with normal submit if CSRF token is already there
      if (form.elements['authenticity_token']?.value) return;

      // otherwise, fetch the CSRF token, attach it to the form, then submit
      event.preventDefault();

      const { data } = await dispatch(fetchLogin(undefined)).unwrap();
      const { csrf_token } = data;
      if (csrf_token) {
        // Set directly on the DOM element to avoid a React re-render race condition
        // where Safari fires form.submit() before the state update commits to the DOM.
        form.elements['authenticity_token'].value = csrf_token;
        form.submit();
      }
    },
    [dispatch]
  );

  const OauthParams = new URLSearchParams({
    for: oauthFor,
    origin: window.location.href,
  });

  return (
    <form
      method="post"
      action={`/api/v1/auth/${
        variant === 'gcal' ? 'google_oauth2' : 'microsoft_graph'
      }?${OauthParams}`}
      onSubmit={onSubmit}
    >
      <input type="hidden" name="authenticity_token" defaultValue="" />
      {variant === 'gcal' && (
        <input type="hidden" name="login_hint" value={user?.email || ''} />
      )}
      {children}
    </form>
  );
};
